// Build-time configuration sourced from Vite env vars.
// Populate web/.env.local from `cdk deploy` outputs (see web/.env.example).
//
// IMPORTANT: Vite replaces `import.meta.env.XXX` statically at build time,
// but ONLY when the access is a literal property — not dynamic
// (e.g. `import.meta.env[name]`). So we must access each var by name.

const required = (name, value) => {
  if (!value) {
    throw new Error(
      `Missing required env var ${name}. Did you create web/.env.local (local dev) or set the GitHub Actions variable (CI)?`,
    );
  }
  return value;
};

export const config = {
  region: required('VITE_AWS_REGION', import.meta.env.VITE_AWS_REGION),
  userPoolId: required('VITE_USER_POOL_ID', import.meta.env.VITE_USER_POOL_ID),
  userPoolClientId: required('VITE_USER_POOL_CLIENT_ID', import.meta.env.VITE_USER_POOL_CLIENT_ID),
  identityPoolId: required('VITE_IDENTITY_POOL_ID', import.meta.env.VITE_IDENTITY_POOL_ID),
  dynamoTable: required('VITE_DYNAMODB_TABLE', import.meta.env.VITE_DYNAMODB_TABLE),
  // The finance table (infra/lib/data-stack.ts). Not secret and not
  // environment-specific, so a plain constant rather than a VITE_* var.
  // Per-user ONLY: the IAM grant has no `shared` partition and no indexes.
  financeTable: 'jexis-finance-data',
  // Optional: Lambda Function URL of the Coles fetch proxy. When unset, the
  // ingredient editor simply hides its "Coles URL" pre-fill field.
  colesProxyUrl: import.meta.env.VITE_COLES_PROXY_URL || null,
  // Optional: Lambda Function URL of the AI pre-fill proxy. When unset, the
  // itinerary editor simply hides its "Auto-fill" affordances.
  aiPrefillUrl: import.meta.env.VITE_AI_PREFILL_URL || null,
  // Optional: Lambda Function URL of the market-data proxy (prices + RBA FX).
  // When unset, the finance pages run without live prices/exchange rates.
  marketDataUrl: import.meta.env.VITE_MARKET_DATA_URL || null,
  // Base URL for the public itinerary calendar feed (…/calendar/<token>.ics),
  // served from our own domain via CloudFront. Defaults to production so the
  // copied link is always the real jexishome.com URL — even from the dev server
  // (where `location.origin` would otherwise give a non-working localhost URL).
  // Override via .env.local for a different environment.
  calendarFeedBase: import.meta.env.VITE_CALENDAR_FEED_BASE || 'https://jexishome.com/calendar/',
};
